'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _unidecode = require('unidecode');

var _unidecode2 = _interopRequireDefault(_unidecode);

var _reactRouter = require('react-router');

var _preludeExtension = require('prelude-extension');

var _events = require('redux/modules/events');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventsBox = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { load: _events.load }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(EventsBox, _Component);

  function EventsBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EventsBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EventsBox.__proto__ || (0, _getPrototypeOf2.default)(EventsBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ajax: null,
      loading: false,
      selectedEvent: null,
      options: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EventsBox, [{
    key: 'onSearchChange',
    value: function onSearchChange(input) {
      var _this2 = this;

      var query = input.trim();
      var ajax = this.state.ajax;


      if (ajax) {
        clearTimeout(ajax);
      }

      this.setState({
        ajax: setTimeout(function () {
          _this2.loadEvents(query);
        }, 250),
        loading: query.length > 2
      });
    }
  }, {
    key: 'changeEvent',
    value: function changeEvent(selectedEvent) {
      this.setState({ selectedEvent: selectedEvent }, this.handleAdd);
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(event) {
      this.props.removeEvent(event.target.dataset.event);
    }
  }, {
    key: 'handleAdd',
    value: function handleAdd() {
      var _this3 = this;

      var addEvent = this.props.addEvent;
      var selectedEvent = this.state.selectedEvent;


      addEvent(selectedEvent, function () {
        _this3.setState({ selectedEvent: null });
      });
    }
  }, {
    key: 'loadEvents',
    value: function loadEvents(query, callback) {
      var _this4 = this;

      if (query.length > 2) {
        this.setState({
          ajax: null,
          loading: true
        }, function () {
          _this4.props.load({
            title: query
          }).then(function (events) {
            var existingEventIds = _this4.props.except;
            var data = events.result.data;

            var eventsRendered = data.map(function (event) {
              var label = event.title;

              if (existingEventIds.indexOf(event.id) > -1) {
                return null;
              }

              var stringPartitions = (0, _preludeExtension.partitionString)((0, _unidecode2.default)(label).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase());
              var labelPartitions = stringPartitions.length === 0 ? [0, label.length, false] : stringPartitions;

              return (0, _extends3.default)({}, event, {
                label: label,
                labelPartitions: labelPartitions,
                value: event.id
              });
            }).filter(function (ur) {
              return !!ur;
            });

            _this4.setState({
              options: eventsRendered,
              loading: false
            }, callback);
          });
        });
      } else if (query.length <= 2) {
        this.setState({
          options: []
        }, callback);
      }
    }
  }, {
    key: 'renderOption',
    value: function renderOption(item) {
      return _react2.default.createElement(
        'div',
        { className: 'simple-option' },
        item.label,
        ' \u2014 ',
        item.venue.name,
        ' \u2014 ',
        (0, _moment2.default)(item.next_date).format('Do MMMM')
      );
    }
  }, {
    key: 'renderNoResults',
    value: function renderNoResults(query) {
      var polyglot = this.props.polyglot;
      var loading = this.state.loading;


      if (loading) {
        return _react2.default.createElement(
          'div',
          { className: 'no-results-found', style: { fontSize: 13 } },
          polyglot.t('loading')
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'no-results-found', style: { fontSize: 13 } },
        query.inputValue.length <= 2 ? polyglot.t('simpleSelect.typeSome') : polyglot.t('simpleSelect.noResults')
      );
    }
  }, {
    key: 'renderEventRow',
    value: function renderEventRow(event) {
      return _react2.default.createElement(
        'div',
        { className: 'event-role-row', key: event.id },
        _react2.default.createElement(
          'div',
          { className: 'col-sm-10 text-left event-identity' },
          _react2.default.createElement(
            'div',
            { className: 'media' },
            _react2.default.createElement(
              'div',
              { className: 'media-body' },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/events/' + event.id },
                _react2.default.createElement(
                  'h4',
                  { className: 'media-heading' },
                  event.title
                ),
                _react2.default.createElement(
                  'small',
                  null,
                  event.venue ? event.venue.name : '',
                  ' \u2014 ',
                  (0, _moment2.default)(event.next_date).format('Do MMMM')
                )
              )
            )
          )
        ),
        _react2.default.createElement('a', { href: '#', className: 'col-sm-2 row-action result-unlink', 'data-event': event.id, onClick: this.handleRemove.bind(this) })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          events = _props.events,
          polyglot = _props.polyglot;
      var _state = this.state,
          selectedEvent = _state.selectedEvent,
          options = _state.options;

      var localeSortByName = function localeSortByName(eventA, eventB) {
        return eventA.title.toLowerCase().localeCompare(eventB.title.toLowerCase(), 'fr');
      };

      var eventsList = _react2.default.createElement(
        'div',
        { className: 'events-list result' },
        events.sort(localeSortByName).map(this.renderEventRow.bind(this))
      );

      var addEventWidget = _react2.default.createElement(
        'div',
        { className: 'new-event-role-widget' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-7' },
            _react2.default.createElement(_reactSelect2.default, {
              className: 'react-select',
              classNamePrefix: 'react-select',
              onInputChange: this.onSearchChange.bind(this),
              onChange: this.changeEvent.bind(this),
              placeholder: polyglot.t('eventsBox.selectPlaceholder'),
              renderOption: this.renderOption.bind(this),
              noOptionsMessage: this.renderNoResults.bind(this),
              options: options,
              value: selectedEvent })
          )
        )
      );

      return _react2.default.createElement(
        'div',
        { className: 'events-box' },
        _react2.default.createElement(
          'h2',
          { className: 'box-header' },
          polyglot.t('eventsBox.events')
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-content' },
          addEventWidget,
          eventsList
        )
      );
    }
  }]);
  return EventsBox;
}(_react.Component), _class2.propTypes = {
  addEvent: _propTypes2.default.func,
  errors: _propTypes2.default.any,
  events: _propTypes2.default.array.isRequired,
  except: _propTypes2.default.array,
  load: _propTypes2.default.func.isRequired,
  polyglot: _propTypes2.default.object.isRequired,
  removeEvent: _propTypes2.default.func
}, _class2.defaultProps = {
  except: []
}, _temp2)) || _class);
exports.default = EventsBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/EventsBox.js
// module id = 2211
// module chunks = 0